import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import AudioRecorder from './AudioRecorder';

const NuevaConsulta = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Nueva Consulta
        </Typography>
        <AudioRecorder />
      </Box>
    </Container>
  );
};

export default NuevaConsulta; 